<template>
  <main class="hall-scheme-page page">
    <BreadcrumbsComponent
      :title="hallScheme ? hallScheme.title : 'Схема зала'"
      :links="[{ title: 'Схемы залов', to: { name: 'hall_schemes' } }]"
    />
    <div class="container-padding">
      <div v-if="hallScheme" class="hall-scheme-page__inner">
        <div class="hall-scheme-page__body">
          <h2 v-if="hallScheme.title" class="hall-scheme-page__title">{{ hallScheme.title }}</h2>
          <div v-if="hallScheme.description" class="hall-scheme-page__description" v-html="hallScheme.description"></div>
        </div>
        <div v-if="hallScheme.img" class="hall-scheme-page__image">
          <a :href="hallScheme.img.path" @click.prevent="showImage">
            <ImgComponent :img="hallScheme.img" width="1200" height="800" />
          </a>
        </div>
      </div>
      <h2 v-else class="no-info">В данный момент информация отсутствует</h2>
    </div>
  </main>
</template>

<script>
import BreadcrumbsComponent from "components/BreadcrumbsComponent.vue";
import ImgComponent from "components/ImgComponent.vue";
import GalleryModal from "components/modals/components/GalleryModal.vue";
import HALL_SCHEMES_OPEN_PAGE from "gql/pages/HallSchemesOpenPage.graphql";

export default {
  name: "HallSchemeOpenPage",
  metaInfo() {
    const meta = this.$store.state.hallSchemes.hall_schemes_item;
    return {
      title: meta?.title || "Схема зала",
    };
  },
  async asyncData({ res, apollo, store, route }) {
    if (!route.params.id && res) {
      res.status(404);
    }
    await apollo.defaultClient
      .query({
        query: HALL_SCHEMES_OPEN_PAGE,
        variables: {
          id: parseInt(route.params.id),
        },
      })
      .then(({ data }) => {
        if (data) {
          store.dispatch("hallSchemes/save", data);
        } else {
          if (res) {
            res.status(404);
          }
        }
      })
      .catch(() => {});
  },
  computed: {
    hallScheme() {
      return this.$store.state.hallSchemes.hall_schemes_item;
    },
  },
  methods: {
    showImage() {
      if (this.hallScheme && this.hallScheme.img) {
        this.$store.state._modals = [
          {
            component: GalleryModal,
            options: {
              images: [{ img: this.hallScheme.img }],
              index: 0,
            },
          },
        ];
      }
    },
  },
  components: {
    ImgComponent,
    BreadcrumbsComponent,
  },
};
</script>

<style lang="stylus">
.hall-scheme-page {

  &__inner {
    padding 50px 0 0 0
    display grid
    grid-gap 30px
  }

  &__body {
    display grid
    grid-gap 15px
  }

  &__title {
    margin-bottom 0
  }

  &__description {
    font-size 1rem
    line-height 1.6
    color var(--dark)
  }

  &__image {
    display flex
    justify-content center

    a {
      display inline-flex
      width 100%
      max-width 1000px

      img {
        width 100%
        border-radius 10px
        cursor zoom-in
      }
    }
  }
}
</style>
